import {useEffect, useRef} from 'react';

/**
 * Resets table page(s) to 1 whenever `key` changes — for dependencies that
 * live outside `useDataTable` (view mode, broker scope, external filter bars).
 * Skips the initial mount so a deep-linked page param survives.
 *
 * Build `key` by joining the external dependencies into a string, e.g.
 * `${viewMode}|${scope ?? ''}`.
 */
export function useResetPageOnChange(
  key: string,
  ...tables: Array<{setPage: (n: number) => void}>
) {
  const prevKey = useRef(key);
  useEffect(() => {
    if (prevKey.current !== key) {
      prevKey.current = key;
      for (const table of tables) {
        table.setPage(1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
